import wrenLogo from "../../shared/assets/wren.png";

type Props = { onStart: () => void };

export function SurveyIntro({ onStart }: Props) {
  return (
    <div className="mx-auto flex min-h-screen min-h-dvh max-w-md flex-col px-6 py-12 text-center">
      {/* Body is vertically centered in the remaining viewport; Begin sits at the bottom.
          Intro stays centered as a "moment" screen — questions themselves are
          left-aligned for editorial feel. */}
      <div className="flex flex-1 flex-col items-center justify-center">
        <img
          src={wrenLogo}
          alt="Wren"
          className="mb-8 h-16 w-16 rounded-full"
        />
        <h1 className="mb-6 text-[3rem] leading-[1.3]">Help us make Wren better</h1>
        <p className="mb-4 text-[1.25rem] leading-[1.5] text-[color:var(--color-wren-gray-700)]">
          A few quick questions about your experience. Takes about 2 minutes.
        </p>
        <p className="text-[1rem] leading-[1.5] text-[color:var(--color-wren-supporting)]">
          Please be as honest as possible.
        </p>
      </div>
      <button
        type="button"
        onClick={onStart}
        className="w-full bg-[color:var(--color-wren-green)] px-6 py-4 text-[1rem] font-semibold text-white transition-colors duration-150 hover:bg-[color:var(--color-wren-green-dark)] active:bg-[color:var(--color-wren-green-deep)]"
        style={{
          borderRadius: "var(--radius-wren-button)",
          boxShadow: "var(--shadow-wren-button-inset)",
        }}
      >
        Begin
      </button>
    </div>
  );
}
